import type { ListItemIconProps } from '@mui/material';
import MuIListItemIcon from '@mui/material/ListItemIcon';
import { forwardRef } from 'react';

const ListItemIcon = forwardRef<HTMLDivElement, ListItemIconProps>(
  (props, ref) => {
    return <MuIListItemIcon ref={ref} {...props} />;
  },
);
export default ListItemIcon;
